var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}],staticClass:"container"},[_c('el-row',{staticClass:"top"},[_c('el-col',[_c('div',{staticClass:"grid-content bg-purple"},[_c('el-image',{staticStyle:{"height":"54px","float":"left"},attrs:{"src":_vm.logoSrc}})],1)])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }